/* =========================================================
   BIX · motor de la maqueta aprobada, portado a Shopify.
   Carrito = Cart API (/cart.js, /cart/add.js, /cart/change.js).
   Favoritos y "vistos recientemente" = localStorage (objetos).
   Búsqueda predictiva = /search/suggest.json.
   Sugeridos para el despacho rebajado = window.ANT_POOL (Liquid).
========================================================= */
(function(){
  "use strict";
  var CFG = window.ANT_CFG || {};
  var POOL = window.ANT_POOL || [];
  var WISH_KEY = 'bix_wish_v2', RECENT_KEY = 'bix_recent_v2', PERFIL_KEY = 'bix_perfil_v1';
  var THRESHOLD = Number(CFG.envioGratis) || 29990;
  var DESPACHO  = Number(CFG.despachoPrecio) || 1000;
  var DESPACHO_FULL = Number(CFG.despachoFull) || 4100;
  var RETIRO_DIR = CFG.retiroDir || 'Carlota Guzmán 1338, bodega 10, Renca';
  function despachoTxt(){ return money(DESPACHO); }

  /* ---------------- helpers ---------------- */
  function money(n){ n = Math.round(n||0); return '$' + n.toLocaleString('es-CL'); }
  function pct(before, now){ if(!before || before<=now) return 0; return Math.round(((before-now)/before)*100); }
  function cuota(precio, n){ n=n||CFG.cuotasN||3; return money(precio/n); }
  function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function el(html){ var d=document.createElement('div'); d.innerHTML=html.trim(); return d.firstChild; }
  function waLink(text){ return 'https://wa.me/'+CFG.whatsapp+'?text='+encodeURIComponent(text); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function imgW(src, w){ if(!src) return ''; return src.replace(/(&|\?)width=\d+/,'') + (src.indexOf('?')>-1?'&':'?') + 'width=' + w; }
  function fromData(elm){ var d=elm.dataset; return { id:Number(d.fav||d.qadd||d.id), pid:Number(d.pid||0), t:d.title||'', p:Number(d.price||0), b:Number(d.before||0), img:d.img||'', img2:d.img2||'', url:d.url||'#', cat:d.cat||'' }; }

  var ICO = {
    search:'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.6" y2="16.6"/></svg>',
    heart:'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5s-7.6-4.6-10-9.4C.5 7.6 2.4 4 6 4c2 0 3.6 1.1 4.5 2.6C11.4 5.1 13 4 15 4c3.6 0 5.5 3.6 4 7.1-2.4 4.8-10 9.4-10 9.4z"/></svg>',
    heartFill:'<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 20.5s-7.6-4.6-10-9.4C.5 7.6 2.4 4 6 4c2 0 3.6 1.1 4.5 2.6C11.4 5.1 13 4 15 4c3.6 0 5.5 3.6 4 7.1-2.4 4.8-10 9.4-10 9.4z"/></svg>',
    cart:'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1.4"/><circle cx="18" cy="21" r="1.4"/><path d="M2.5 3h2.4l2.6 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21.5 7H6.2"/></svg>',
    arrowR:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    arrowL:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>',
    plus:'<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus:'<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    close:'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check:'<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
    truck:'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="14" height="11"/><path d="M15 10h4l3 3v4h-7z"/><circle cx="6" cy="19" r="1.7"/><circle cx="17.5" cy="19" r="1.7"/></svg>',
    store:'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v11H3z"/><path d="M9 20v-6h6v6"/></svg>'
  };

  /* ================= PRODUCT CARD (desde objeto: favoritos, recientes, buscador de regalos) ================= */
  function productCardHTML(p){
    var save = pct(p.b, p.p);
    var badge = save>0 ? '<span class="badge-off">-'+save+'%</span>' : (p.p>=THRESHOLD ? '<span class="badge-ship">Despacho '+money(DESPACHO)+'</span>' : '');
    var wished = isWished(p.id);
    return (
      '<div class="pcard"'+(p.cat?' data-cat="'+esc(p.cat)+'"':'')+'>'+
        '<div class="imgwrap"'+(p.img2?' data-img2="'+esc(imgW(p.img2,500))+'"':'')+'>'+
          (badge ? '<div class="badges">'+badge+'</div>' : '')+
          '<img src="'+imgW(p.img,500)+'" alt="'+esc(p.t)+'" loading="lazy">'+
          '<a href="'+p.url+'" class="imgwrap-link" aria-label="Ver '+esc(p.t)+'"></a>'+
          '<div class="card-icons"><button class="fav reset-btn'+(wished?' active':'')+'" data-fav="'+p.id+'" data-title="'+esc(p.t)+'" data-price="'+p.p+'" data-before="'+(p.b||0)+'" data-img="'+esc(p.img)+'" data-url="'+esc(p.url)+'" aria-label="Agregar a favoritos"><span class="fav-ico">'+(wished?ICO.heartFill:ICO.heart)+'</span></button></div>'+
          '<button class="qadd-fab reset-btn" data-qadd="'+p.id+'" data-title="'+esc(p.t)+'" aria-label="Agregar al carro">'+ICO.plus+'</button>'+
        '</div>'+
        '<a href="'+p.url+'" class="body"><span class="name">'+esc(p.t)+'</span>'+
          '<div class="price-row"><span class="price">'+money(p.p)+'</span>'+(save>0?'<span class="before">'+money(p.b)+'</span>':'')+'</div>'+
          (save>0?'<span class="save">Ahorra '+money(p.b-p.p)+' ('+save+'%)</span>':'')+
          (CFG.cuotas?'<span class="cuotas">'+(CFG.cuotasN||3)+'x '+cuota(p.p)+' sin interés</span>':'')+
        '</a>'+
      '</div>'
    );
  }

  /* ================= CARRITO (Shopify Cart API) ================= */
  var cart = null;
  function api(path, body){
    return fetch(path, { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description||j.message||'cart'); return j; }); });
  }
  function fetchCart(){ return fetch('/cart.js', { credentials:'same-origin' }).then(function(r){ return r.json(); }).then(function(c){ cart=c; updateCartCount(); return c; }); }
  function cartLines(){ return cart ? cart.items : []; }
  function cartSubtotal(){ return cart ? cart.items_subtotal_price/100 : 0; }
  function cartCount(){ return cart ? cart.item_count : 0; }
  function afterChange(){ return fetchCart().then(function(){ renderCartDrawer(); if(window.BIX_ON_CART_PAGE) window.BIX_ON_CART_PAGE(); }); }
  function addToCart(id, qty){ return api('/cart/add.js', { items:[{ id:Number(id), quantity:qty||1 }] }).then(afterChange); }
  function addMany(ids){
    var seen={}, items=[];
    ids.forEach(function(id){ id=Number(id); if(!id) return; if(seen[id]){ seen[id].quantity++; } else { seen[id]={ id:id, quantity:1 }; items.push(seen[id]); } });
    return api('/cart/add.js', { items:items }).then(afterChange);
  }
  function changeLine(key, qty){ return api('/cart/change.js', { id:key, quantity:qty }).then(afterChange); }
  function removeFromCart(key){ return changeLine(key, 0); }
  function setQty(key, qty){ return changeLine(key, Math.max(1, qty)); }
  function updateCartCount(){
    qsa('.js-cart-count').forEach(function(b){ var n=cartCount(); b.textContent=n; b.classList.toggle('hidden', n===0); b.classList.add('bump'); setTimeout(function(){ b.classList.remove('bump'); },350); });
  }
  /* Sugeridos para cerrar la brecha hasta el despacho barato. Dos reglas:
     cerrar la brecha de verdad (no sugerir algo que deja a la persona igual de lejos)
     y, entre los que sirven, preferir las categorías que viene mirando. */
  function shippingSuggestions(currentPrice, excludeIds, threshold){
    var remaining = threshold - currentPrice;
    if(remaining<=0) return [];
    var favs = categoriasTop(3);
    function afin(p){ var i=favs.indexOf((p.c||'').trim()); return i===-1 ? 0 : 3-i; }
    var pool = POOL.filter(function(p){ return excludeIds.indexOf(p.id)===-1; });
    /* 1) un solo producto cierra la brecha: el que menos se pasa, pero si hay varios
          parecidos (±25%) gana el de la categoría que viene mirando */
    var cubren = pool.filter(function(p){ return p.p>=remaining; }).sort(function(a,b){ return a.p-b.p; });
    if(cubren.length){
      var techo = cubren[0].p*1.25;
      var cerca = cubren.filter(function(p){ return p.p<=techo; });
      cerca.sort(function(a,b){ return afin(b)-afin(a) || a.p-b.p; });
      return [cerca[0]];
    }
    /* 2) ninguno alcanza solo: armamos la combinación más corta, empezando por lo
          que le interesa y de mayor a menor precio */
    var sorted = pool.slice().sort(function(a,b){ return afin(b)-afin(a) || b.p-a.p; });
    var chosen=[], sum=0;
    for(var i=0;i<sorted.length && sum<remaining && chosen.length<4;i++){ chosen.push(sorted[i]); sum+=sorted[i].p; }
    return chosen;
  }

  /* ================= PERFIL DE NAVEGACIÓN =================
     Qué categorías viene mirando la persona y en qué rango de precio se mueve.
     Vive sólo en SU navegador: no viaja a ningún servidor ni identifica a nadie.
     Lo viejo pesa menos cada día, así que el perfil sigue a la visita de hoy. */
  var PESO = { ver:1, favorito:3, carro:5, coleccion:2 };
  function getPerfil(){
    try{ var p=JSON.parse(localStorage.getItem(PERFIL_KEY)); if(p && p.cat) return p; }catch(e){}
    return { cat:{}, nom:{}, precio:0, n:0, dia:0 };
  }
  /* cat = handle de la colección (es la categoría que de verdad tienen los productos
     de BIX; el product_type viene vacío en el 77%). nombre = cómo mostrarla. */
  function tocaPerfil(cat, nombre, precio, peso){
    cat=(cat||'').trim(); if(!cat && !precio) return;
    var p=getPerfil(), hoy=Math.floor(Date.now()/864e5);
    if(p.dia && p.dia<hoy){
      var f=Math.pow(0.85, Math.min(30, hoy-p.dia));
      for(var k in p.cat){ p.cat[k]*=f; if(p.cat[k]<0.3){ delete p.cat[k]; delete (p.nom||{})[k]; } }
    }
    p.dia=hoy; p.nom=p.nom||{};
    if(cat){ p.cat[cat]=(p.cat[cat]||0)+(peso||1); if(nombre) p.nom[cat]=nombre; }
    if(precio>0) p.precio = p.precio ? Math.round(p.precio*0.7 + precio*0.3) : precio;
    p.n=(p.n||0)+1;
    try{ localStorage.setItem(PERFIL_KEY, JSON.stringify(p)); }catch(e){}
  }
  function categoriasTop(n){
    var c=getPerfil().cat||{};
    return Object.keys(c).sort(function(a,b){ return c[b]-c[a]; }).slice(0, n||3);
  }
  function nombreCat(h){ var p=getPerfil(); return (p.nom||{})[h] || h; }
  /* ¿sabemos algo de esta persona? dos señales ya bastan para no mostrar cualquier cosa */
  function perfilUtil(){ return (getPerfil().n||0) >= 2 && categoriasTop(1).length > 0; }

  /* ================= VISTOS RECIENTEMENTE ================= */
  function getRecent(){ try{ return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }catch(e){ return []; } }
  function recordView(p){ var r=getRecent().filter(function(x){ return x.id!==p.id; }); r.unshift(p); try{ localStorage.setItem(RECENT_KEY, JSON.stringify(r.slice(0,12))); }catch(e){} }
  function recentProducts(excludeId, limit){ return getRecent().filter(function(x){ return x.id!==Number(excludeId); }).slice(0, limit||4); }

  /* ================= WISHLIST ================= */
  function getWish(){ try{ return JSON.parse(localStorage.getItem(WISH_KEY)) || []; }catch(e){ return []; } }
  function setWish(w){ try{ localStorage.setItem(WISH_KEY, JSON.stringify(w)); }catch(e){} updateWishCount(); }
  function isWished(id){ return getWish().some(function(x){ return x.id===Number(id); }); }
  function toggleWish(p){
    var w=getWish(), i=w.findIndex(function(x){ return x.id===p.id; });
    if(i>-1) w.splice(i,1); else w.push(p);
    setWish(w);
    qsa('[data-fav="'+p.id+'"]').forEach(function(b){ b.classList.toggle('active', isWished(p.id)); var ico=b.querySelector('.fav-ico')||b; ico.innerHTML = isWished(p.id)?ICO.heartFill:ICO.heart; });
    renderWishDrawer();
    return isWished(p.id);
  }
  function updateWishCount(){ qsa('.js-wish-count').forEach(function(b){ var n=getWish().length; b.textContent=n; b.classList.toggle('hidden', n===0); }); }
  function paintWished(root){ getWish().forEach(function(p){ qsa('[data-fav="'+p.id+'"]', root).forEach(function(b){ b.classList.add('active'); var ico=b.querySelector('.fav-ico')||b; ico.innerHTML=ICO.heartFill; }); }); }

  /* ================= TOAST ================= */
  var toastTimer;
  function toast(msg){
    var t=qs('#bixToast');
    if(!t){ t=el('<div class="toast" id="bixToast">'+ICO.check+'<span></span></div>'); document.body.appendChild(t); }
    t.querySelector('span').textContent=msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer=setTimeout(function(){ t.classList.remove('show'); }, 2600);
  }

  /* ================= CART DRAWER ================= */
  function renderCartDrawer(){
    var body=qs('#cartBody'), foot=qs('#cartFoot'), prog=qs('#cartProgress');
    if(!body || !cart) return;
    var lines=cartLines(), subtotal=cartSubtotal();
    if(lines.length===0){
      body.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24" width="54" height="54" fill="none" stroke="var(--line)" stroke-width="1.4"><circle cx="9" cy="21" r="1.4"/><circle cx="18" cy="21" r="1.4"/><path d="M2.5 3h2.4l2.6 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21.5 7H6.2"/></svg><h4 class="h3" style="font-size:17px">Tu carrito está vacío</h4><p style="font-size:13px;color:var(--ink-soft)">¿No sabes qué llevar?</p><a class="btn btn-primary btn-sm" href="'+CFG.routes.gifts+'">Buscar un regalo</a></div>';
      prog.innerHTML=''; foot.innerHTML=''; return;
    }
    var remaining = THRESHOLD - subtotal;
    prog.innerHTML = remaining<=0
      ? '<div class="msg">'+ICO.check+' ¡Tu pedido tiene despacho a '+despachoTxt()+' en la RM!</div><div class="bar"><i style="width:100%"></i></div>'
      : '<div class="msg">'+ICO.truck+' Te faltan '+money(remaining)+' para el despacho a '+despachoTxt()+'</div><div class="bar"><i style="width:'+Math.round((subtotal/THRESHOLD)*100)+'%"></i></div>';
    body.innerHTML = lines.map(function(l){
      return '<div class="cart-line"><a href="'+l.url+'"><img src="'+imgW(l.image,150)+'" alt=""></a><div class="info"><a href="'+l.url+'" class="name">'+esc(l.product_title)+(l.variant_title && l.variant_title!=='Default Title' ? ' · '+esc(l.variant_title):'')+'</a>'+
        '<div class="row"><div class="qty-stepper"><button class="reset-btn" data-cqty="'+l.key+'" data-op="-1">'+ICO.minus+'</button><span>'+l.quantity+'</span><button class="reset-btn" data-cqty="'+l.key+'" data-op="1">'+ICO.plus+'</button></div><span class="price">'+money(l.final_line_price/100)+'</span></div>'+
        '<button class="rm reset-btn" data-crm="'+l.key+'">Quitar</button></div></div>';
    }).join('');
    if(remaining>0){
      var inCart = lines.map(function(l){ return l.variant_id; });
      var sug = shippingSuggestions(subtotal, inCart, THRESHOLD).slice(0,3);
      if(sug.length){
        var cierra = sug.reduce(function(t,x){ return t+x.p; },0) >= remaining;
        body.innerHTML += '<div class="cart-cross"><h4>Suma y baja tu despacho a '+despachoTxt()+'</h4>'+
          sug.map(function(sp){ return '<div class="cross-item"><img src="'+imgW(sp.img,100)+'" alt=""><span class="n">'+esc(sp.t)+'</span><span class="p">'+money(sp.p)+'</span><button class="add reset-btn" data-qadd="'+sp.id+'" data-title="'+esc(sp.t)+'" data-cat="'+esc(sp.c||'')+'" data-price="'+sp.p+'">'+ICO.plus+'</button></div>'; }).join('')+
          (sug.length>1 && cierra ? '<button class="btn btn-outline btn-block btn-sm" id="crossAll" type="button" style="margin-top:10px">Agregar los '+sug.length+' y listo</button>' : '')+
          '</div>';
        var allBtn=qs('#crossAll', body);
        if(allBtn) allBtn.addEventListener('click', function(){ allBtn.disabled=true; addMany(sug.map(function(x){ return x.id; })).then(function(){ toast('Listo: tu pedido ya tiene el despacho a '+despachoTxt()); }); });
      }
    }
    foot.innerHTML = '<div class="cart-subtotal"><span>Subtotal</span><span>'+money(subtotal)+'</span></div><a class="btn btn-dark btn-block" href="'+CFG.routes.cart+'">Ver carrito y pagar</a><p class="cart-note"><b>Despacho a domicilio:</b> '+despachoTxt()+' en la RM sobre '+money(THRESHOLD)+' ('+money(DESPACHO_FULL)+' bajo ese monto).<br><b>Retiro en bodega $0:</b> no es despacho, lo retiras tú en '+RETIRO_DIR+'.</p>';
    qsa('[data-cqty]', body).forEach(function(b){ b.addEventListener('click', function(){ var key=b.getAttribute('data-cqty'), op=Number(b.getAttribute('data-op')); var line=cartLines().find(function(l){ return l.key===key; }); if(!line) return; var q=line.quantity+op; if(q<=0) removeFromCart(key); else setQty(key,q); }); });
    qsa('[data-crm]', body).forEach(function(b){ b.addEventListener('click', function(){ removeFromCart(b.getAttribute('data-crm')); }); });
  }
  function openCartDrawer(){ var s=qs('#cartScrim'), d=qs('#cartDrawer'); if(!d) return; s.classList.add('open'); d.classList.add('open'); document.documentElement.style.overflow='hidden'; }
  function closeCartDrawer(){ var s=qs('#cartScrim'), d=qs('#cartDrawer'); if(!d) return; s.classList.remove('open'); d.classList.remove('open'); document.documentElement.style.overflow=''; }

  /* ================= WISHLIST DRAWER ================= */
  function renderWishDrawer(){
    var body=qs('#wishBody'); if(!body) return;
    var items=getWish();
    if(items.length===0){ body.innerHTML='<div class="cart-empty">'+ICO.heart.replace('width="20" height="20"','width="54" height="54"')+'<h4 class="h3" style="font-size:17px">Aún no tienes favoritos</h4><p style="font-size:13px;color:var(--ink-soft)">Toca el corazón en cualquier producto para guardarlo.</p><a class="btn btn-outline btn-sm" href="'+CFG.routes.shop+'">Ver catálogo</a></div>'; return; }
    body.innerHTML = items.map(function(p){ return '<div class="cart-line"><a href="'+p.url+'"><img src="'+imgW(p.img,150)+'" alt=""></a><div class="info"><a href="'+p.url+'" class="name">'+esc(p.t)+'</a><div class="row"><span class="price">'+money(p.p)+'</span></div><button class="rm reset-btn" data-wrm="'+p.id+'">Quitar</button></div></div>'; }).join('');
    qsa('[data-wrm]', body).forEach(function(b){ b.addEventListener('click', function(){ var p=getWish().find(function(x){ return x.id===Number(b.getAttribute('data-wrm')); }); if(p) toggleWish(p); }); });
  }
  function openWishDrawer(){ renderWishDrawer(); qs('#wishScrim').classList.add('open'); qs('#wishDrawer').classList.add('open'); document.documentElement.style.overflow='hidden'; }
  function closeWishDrawer(){ var s=qs('#wishScrim'), d=qs('#wishDrawer'); if(!d) return; s.classList.remove('open'); d.classList.remove('open'); document.documentElement.style.overflow=''; }

  /* ================= clicks delegados: favoritos, quick add ================= */
  document.addEventListener('click', function(e){
    var fav=e.target.closest('[data-fav]'), qadd=e.target.closest('[data-qadd]');
    if(fav){ e.preventDefault(); e.stopPropagation(); var fp=fromData(fav); var wished=toggleWish(fp); if(wished) tocaPerfil(fp.cat, fav.getAttribute('data-catn'), fp.p, PESO.favorito); toast(wished?'Agregado a tus favoritos':'Quitado de favoritos'); }
    else if(qadd){
      e.preventDefault(); e.stopPropagation();
      var id=Number(qadd.getAttribute('data-qadd')), title=qadd.getAttribute('data-title')||'el producto';
      tocaPerfil(qadd.getAttribute('data-cat'), qadd.getAttribute('data-catn'), Number(qadd.getAttribute('data-price'))||0, PESO.carro);
      qadd.classList.add('is-loading');
      addToCart(id,1).then(function(){ toast('Agregaste "'+title+'" al carro'); openCartDrawer(); }).catch(function(err){ toast('No pudimos agregarlo: '+(err.message||'intenta de nuevo')); }).then(function(){ qadd.classList.remove('is-loading'); });
    }
  });

  /* ================= HEADER ================= */
  function wireHeader(){
    var navCats=qs('#navCats'); if(!navCats) return;
    var mm=qs('.megamenu', navCats);
    function openMM(){ navCats.classList.add('open'); requestAnimationFrame(function(){ mm.classList.add('showing'); }); }
    function closeMM(){ mm.classList.remove('showing'); navCats.classList.remove('open'); }
    navCats.addEventListener('mouseenter', openMM); navCats.addEventListener('mouseleave', closeMM);
    qs('.nav-link', navCats).addEventListener('click', function(e){ if(window.matchMedia('(hover:none)').matches){ e.preventDefault(); navCats.classList.contains('open')?closeMM():openMM(); } });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeMM(); });
    /* pills = tabs: muestran su panel (todos vienen renderizados) */
    function showPanel(i){ qsa('.mm-pill', mm).forEach(function(b){ b.classList.toggle('active', Number(b.getAttribute('data-mmcat'))===i); }); qsa('[data-mmpanel]', mm).forEach(function(p){ p.hidden = Number(p.getAttribute('data-mmpanel'))!==i; }); }
    qsa('.mm-pill', mm).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); showPanel(Number(b.getAttribute('data-mmcat'))); }); b.addEventListener('mouseover', function(){ if(!b.classList.contains('active')) showPanel(Number(b.getAttribute('data-mmcat'))); }); });
    /* mobile drawer */
    var mnav=qs('#mnav'), mscrim=qs('#mnavScrim');
    function openMnav(){ mnav.classList.add('open'); mscrim.classList.add('open'); document.documentElement.style.overflow='hidden'; }
    function closeMnav(){ mnav.classList.remove('open'); mscrim.classList.remove('open'); document.documentElement.style.overflow=''; }
    qs('#btnBurger').addEventListener('click', openMnav); qs('#mnavClose').addEventListener('click', closeMnav); mscrim.addEventListener('click', closeMnav);
    qsa('[data-mnavcat]').forEach(function(btn){ btn.addEventListener('click', function(){ var wrap=btn.parentNode, sub=wrap.querySelector('.mnav-sub'); var open=wrap.classList.toggle('open'); btn.setAttribute('aria-expanded', open?'true':'false'); if(sub) sub.hidden=!open; }); });
    qs('#btnCart').addEventListener('click', openCartDrawer);
    qs('#btnWish').addEventListener('click', openWishDrawer);
    var msb=qs('#btnSearchMobile'); if(msb) msb.addEventListener('click', openMnav);
    /* búsqueda predictiva (Shopify Predictive Search API) */
    var input=qs('#headerSearchInput'), box=qs('#searchSuggest'), t;
    function renderSuggest(q){
      if(!q){ box.classList.add('hidden'); return; }
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', { credentials:'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(j){
          var list=((j.resources||{}).results||{}).products||[];
          if(input.value.trim()!==q) return;
          box.classList.remove('hidden');
          if(!list.length){ box.innerHTML='<div class="search-empty">Sin resultados para "'+esc(q)+'"</div>'; return; }
          box.innerHTML = list.map(function(p){ return '<a href="'+p.url+'"><img src="'+imgW(p.featured_image&&p.featured_image.url,100)+'" alt=""><div><div class="sname">'+esc(p.title)+'</div><div class="sprice">'+money(Number(p.price))+'</div></div></a>'; }).join('')+
            '<a href="'+CFG.routes.search+'?q='+encodeURIComponent(q)+'&type=product" style="justify-content:center;font-weight:700;font-size:13px;color:var(--ink)">Ver todos los resultados '+ICO.arrowR+'</a>';
        }).catch(function(){});
    }
    if(input && box){
      input.addEventListener('input', function(){ clearTimeout(t); var q=input.value.trim(); t=setTimeout(function(){ renderSuggest(q); }, 180); });
      input.addEventListener('focus', function(){ if(input.value.trim()) renderSuggest(input.value.trim()); });
      document.addEventListener('click', function(e){ if(!e.target.closest('.header-search')) box.classList.add('hidden'); });
    }
  }

  /* ================= OVERLAYS ================= */
  function closeHsSheet(){ var s=qs('#hsSheet'), sc=qs('#hsSheetScrim'); if(!s) return; s.classList.remove('open'); sc.classList.remove('open'); document.documentElement.style.overflow=''; }
  function openHsSheet(p){
    var body=qs('#hsSheetBody'); if(!body) return;
    var save=pct(p.b,p.p);
    body.innerHTML='<img src="'+imgW(p.img,200)+'" alt=""><div class="hs-sheet-info"><span class="cat">'+esc(p.cat)+'</span><span class="name">'+esc(p.t)+'</span><span class="price-row"><span class="price">'+money(p.p)+'</span>'+(save>0?'<span class="before">'+money(p.b)+'</span>':'')+'</span></div>';
    body.parentNode.querySelectorAll('.hs-sheet-addbtn').forEach(function(b){ b.remove(); });
    var addBtn=el('<button class="btn btn-dark hs-sheet-addbtn" data-qadd="'+p.id+'" data-title="'+esc(p.t)+'">'+ICO.cart+' Agregar al carro</button>');
    body.parentNode.appendChild(addBtn);
    qs('#hsSheet').classList.add('open'); qs('#hsSheetScrim').classList.add('open'); document.documentElement.style.overflow='hidden';
  }
  function wireOverlays(){
    var pairs=[['#cartClose',closeCartDrawer],['#cartScrim',closeCartDrawer],['#wishClose',closeWishDrawer],['#wishScrim',closeWishDrawer],['#hsSheetClose',closeHsSheet],['#hsSheetScrim',closeHsSheet]];
    pairs.forEach(function(p){ var e=qs(p[0]); if(e) e.addEventListener('click', p[1]); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeCartDrawer(); closeWishDrawer(); closeHsSheet(); } });
  }

  /* ================= REVEAL ================= */
  function initReveal(){
    var io=new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } }); }, { threshold:.12 });
    qsa('.reveal').forEach(function(e){ io.observe(e); });
  }

  /* ================= HOME: hero ================= */
  function initHero(){
    var root=qs('#heroSlides'); if(!root) return;
    var els=qsa('.hero-slide', root), dots=qsa('.hero-dot', root); if(els.length<2) return;
    var idx=0, timer;
    function show(n){ idx=(n+els.length)%els.length; els.forEach(function(e,i){ e.classList.toggle('active', i===idx); }); dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); }); restart(); }
    function restart(){ clearTimeout(timer); timer=setTimeout(function(){ show(idx+1); }, 6500); }
    var prev=qs('#heroPrev'), next=qs('#heroNext');
    if(prev) prev.addEventListener('click', function(){ show(idx-1); });
    if(next) next.addEventListener('click', function(){ show(idx+1); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ show(Number(d.getAttribute('data-dot'))); }); });
    restart();
  }

  /* ================= HOME: masonry + hotspots ================= */
  function initMasonry(){
    var root=qs('#masonryGallery'); if(!root) return;
    function closeAllPops(){ qsa('.hotspot-pop', root).forEach(function(p){ p.remove(); }); qsa('.hotspot-dot.active', root).forEach(function(b){ b.classList.remove('active'); }); }
    function openPop(btn, p){
      closeAllPops(); btn.classList.add('active');
      var left=parseFloat(btn.style.left), top=parseFloat(btn.style.top), save=pct(p.b,p.p);
      var pop=document.createElement('div'); pop.className='hotspot-pop dir-'+(top>50?'t':'b')+(left>50?'l':'r'); pop.style.left=left+'%'; pop.style.top=top+'%';
      pop.innerHTML='<button class="hp-close reset-btn" aria-label="Cerrar">'+ICO.close+'</button><img src="'+imgW(p.img,200)+'" alt=""><div class="hp-body"><span class="hp-cat">'+esc(p.cat)+'</span><span class="hp-name">'+esc(p.t)+'</span><span class="hp-price-row"><span class="hp-price">'+money(p.p)+'</span>'+(save>0?'<span class="hp-before">'+money(p.b)+'</span>':'')+'</span><button class="btn btn-dark btn-sm" data-qadd="'+p.id+'" data-title="'+esc(p.t)+'">'+ICO.cart+' Agregar</button></div>';
      btn.parentNode.appendChild(pop);
      pop.querySelector('.hp-close').addEventListener('click', function(e){ e.stopPropagation(); closeAllPops(); });
    }
    qsa('.hotspot-dot', root).forEach(function(btn){
      btn.addEventListener('click', function(){
        var p=fromData(btn);
        if(window.matchMedia('(max-width:640px)').matches){ closeAllPops(); openHsSheet(p); return; }
        if(btn.classList.contains('active')){ closeAllPops(); return; }
        openPop(btn, p);
      });
    });
    document.addEventListener('click', function(e){ if(!e.target.closest('.hotspot-dot') && !e.target.closest('.hotspot-pop')) closeAllPops(); });
  }




  /* ================= Destacados con pestañas ================= */
  function initDestacados(){
    qsa('.dest').forEach(function(sec){
      var tabs=qsa('.dest-tab', sec), paneles=qsa('.dest-panel', sec);
      if(!tabs.length) return;
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var i=tab.getAttribute('data-dtab');
          tabs.forEach(function(t){ t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
          tab.classList.add('active'); tab.setAttribute('aria-selected','true');
          paneles.forEach(function(p){
            var suyo = p.getAttribute('data-dpanel')===i;
            p.hidden = !suyo;
            p.classList.toggle('active', suyo);
          });
          /* el carrusel del panel recién visible necesita recalcular sus flechas */
          var vis=paneles.filter(function(p){ return !p.hidden; })[0];
          if(vis){ var row=qs('.prow', vis); if(row) row.dispatchEvent(new Event('scroll')); }
        });
      });
    });
  }

  /* ================= Cuenta regresiva de campaña ================= */
  function initCyberReloj(){
    qsa('.cyber-reloj').forEach(function(box){
      var fin = Number(box.getAttribute('data-fin'))*1000;
      if(!fin || isNaN(fin)) return;
      var campos = {};
      ['d','h','m','s'].forEach(function(k){ campos[k]=qs('[data-cr="'+k+'"]', box); });
      function dos(n){ return (n<10?'0':'')+n; }
      function tic(){
        var falta = fin - Date.now();
        if(falta <= 0){ box.hidden = true; clearInterval(t); return; }
        var seg = Math.floor(falta/1000);
        campos.d.textContent = dos(Math.floor(seg/86400));
        campos.h.textContent = dos(Math.floor(seg%86400/3600));
        campos.m.textContent = dos(Math.floor(seg%3600/60));
        campos.s.textContent = dos(seg%60);
        box.hidden = false;
      }
      tic();
      var t = setInterval(tic, 1000);
    });
  }

  /* ================= Carrusel de filas de producto ================= */
  function initProwCarruseles(){
    qsa('.prow-wrap').forEach(function(wrap){
      var row = qs('.prow', wrap), prev = qs('.prow-prev', wrap), next = qs('.prow-next', wrap);
      if(!row || !prev || !next) return;
      function paso(){
        var first = row.children[0];
        if(!first) return Math.round(row.clientWidth * 0.8);
        var gap = parseFloat(getComputedStyle(row).gap) || 18;
        var ancho = first.getBoundingClientRect().width + gap;
        var caben = Math.max(1, Math.floor(row.clientWidth / ancho));
        return Math.round(ancho * Math.max(1, caben - 1));
      }
      function estado(){
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.hidden = row.scrollLeft <= 2;
        next.hidden = row.scrollLeft >= max;
      }
      prev.addEventListener('click', function(){ row.scrollBy({left: -paso(), behavior:'smooth'}); });
      next.addEventListener('click', function(){ row.scrollBy({left:  paso(), behavior:'smooth'}); });
      row.addEventListener('scroll', estado, {passive:true});
      window.addEventListener('resize', estado);
      estado();
    });
  }

  /* ================= HOME: packs ================= */
  function initPacks(){
    qsa('[data-packadd]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var ids=(btn.getAttribute('data-ids')||'').split(',').filter(Boolean);
        var title=btn.getAttribute('data-title')||'el pack';
        btn.disabled=true;
        addMany(ids).then(function(){ toast('Agregaste "'+title+'" al carro'); openCartDrawer(); }).catch(function(){ toast('No pudimos agregar el pack'); }).then(function(){ btn.disabled=false; });
      });
    });
  }

  /* ================= TIENDAS (home condensado + página) ================= */
  function initStores(){
    qsa('[data-ant-stores]').forEach(function(root){
      var limit=Number(root.getAttribute('data-limit'))||0, cards=qsa('.store-card[data-region]', root), chips=qsa('[data-region-chip]', root);
      var sub=qs('[data-comunas]', root), more=qs('[data-more]', root), count=qs('[data-count]', root);
      var active=qs('[data-region-chip].active', root);
      var state={ region: active? active.getAttribute('data-region-chip') : 'Todas', comuna:'Todas' };
      function render(){
        chips.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-region-chip')===state.region); });
        var list=cards.filter(function(c){ return (state.region==='Todas'||c.getAttribute('data-region')===state.region) && (state.comuna==='Todas'||c.getAttribute('data-comuna')===state.comuna); });
        var shown=0; cards.forEach(function(c){ var ok=list.indexOf(c)>-1 && (!limit||shown<limit); c.hidden=!ok; if(ok) shown++; });
        if(more){ var rest=list.length-shown; more.hidden=rest<=0; var where=state.region==='Todas'?' en Chile':(state.region==='Región Metropolitana'?' en la Región Metropolitana':' en '+state.region); more.innerHTML='<span>+'+rest+' tienda'+(rest===1?'':'s')+' más'+where+'</span><span class="go">Ver todas '+ICO.arrowR+'</span>'; }
        if(count) count.textContent=list.length+(list.length===1?' tienda':' tiendas');
        if(sub){
          var comunas=[]; cards.forEach(function(c){ if(state.region==='Todas'||c.getAttribute('data-region')===state.region){ var k=c.getAttribute('data-comuna'); if(comunas.indexOf(k)===-1) comunas.push(k); } });
          comunas.sort();
          if(state.region==='Todas'||comunas.length<2){ sub.hidden=true; sub.innerHTML=''; return; }
          sub.hidden=false;
          sub.innerHTML=['Todas'].concat(comunas).map(function(c){ return '<button type="button" class="comuna-chip comuna-chip--sub reset-btn'+(state.comuna===c?' active':'')+'" data-comuna-chip="'+esc(c)+'">'+esc(c)+'</button>'; }).join('');
          qsa('[data-comuna-chip]', sub).forEach(function(b){ b.addEventListener('click', function(){ state.comuna=b.getAttribute('data-comuna-chip'); render(); }); });
        }
      }
      chips.forEach(function(b){ b.addEventListener('click', function(){ state.region=b.getAttribute('data-region-chip'); state.comuna='Todas'; render(); }); });
      render();
    });
  }

  /* ================= PDP ================= */
  function initPdp(){
    var form=qs('#pdpForm'); if(!form) return;
    var p=fromData(form);
    tocaPerfil(p.cat, form.getAttribute('data-catn'), p.p, PESO.ver);
    recordView({ id:p.id, pid:p.pid, t:p.t, p:p.p, b:p.b, img:p.img, img2:p.img2, url:p.url, cat:p.cat });
    /* galería */
    var main=qs('#pdpMainImg');
    qsa('.pdp-thumb').forEach(function(t){ t.addEventListener('click', function(){ qsa('.pdp-thumb').forEach(function(x){ x.classList.remove('active'); }); t.classList.add('active'); main.src=t.getAttribute('data-src'); }); });
    /* cantidad */
    qsa('[data-pdpqty]').forEach(function(btn){ btn.addEventListener('click', function(){ var span=qs('#pdpQtyVal'), inp=qs('#pdpQtyInput'); var v=Math.max(1, parseInt(span.textContent,10)+Number(btn.getAttribute('data-pdpqty'))); span.textContent=v; if(inp) inp.value=v; }); });
    /* variante → precio */
    var sel=qs('#pdpVariant');
    function currentVariantId(){ return sel ? Number(sel.value) : p.id; }
    /* agregar (AJAX) */
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var qty=parseInt((qs('#pdpQtyVal')||{textContent:'1'}).textContent,10)||1;
      var btn=qs('#pdpAddBtn'); btn.disabled=true;
      addToCart(currentVariantId(), qty).then(function(){ toast('Agregaste "'+p.t+'" al carro'); openCartDrawer(); }).catch(function(err){ toast('No pudimos agregarlo: '+(err.message||'')); }).then(function(){ btn.disabled=false; });
    });
    /* favorito */
    var favBtn=qs('#pdpFavBtn');
    if(favBtn){ function paint(){ favBtn.innerHTML=isWished(p.id)?ICO.heartFill:ICO.heart; favBtn.classList.toggle('active', isWished(p.id)); } paint(); favBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); toggleWish({ id:p.id, pid:p.pid, t:p.t, p:p.p, b:p.b, img:p.img, img2:p.img2, url:p.url, cat:p.cat }); paint(); toast(isWished(p.id)?'Agregado a tus favoritos':'Quitado de favoritos'); }); }
    /* barra del despacho rebajado con sugeridos concretos */
    var ship=qs('#shipBar');
    if(ship){
      if(p.p>=THRESHOLD){ ship.innerHTML='<div class="ship-ok">'+ICO.check+' ¡Este producto ya tiene despacho a '+despachoTxt()+' en la RM!</div>'; }
      else {
        var sug=shippingSuggestions(p.p, [p.id], THRESHOLD), remaining=THRESHOLD-p.p;
        if(sug.length){
          ship.innerHTML='<div class="ship-bar"><div class="head">'+ICO.truck+' Te faltan <span class="mono" style="color:var(--ink)">'+money(remaining)+'</span> para el despacho a '+despachoTxt()+'</div><div class="bar"><i style="width:'+Math.round((p.p/THRESHOLD)*100)+'%"></i></div><div class="ship-suggest">'+
            sug.map(function(sp){ return '<button class="ship-opt reset-btn" data-qadd="'+sp.id+'" data-title="'+esc(sp.t)+'"><img src="'+imgW(sp.img,100)+'" alt="">'+esc(sp.t.slice(0,26))+(sp.t.length>26?'…':'')+'<span class="p">+'+money(sp.p)+'</span></button>'; }).join('')+
            '</div>'+
            (sug.reduce(function(t,x){ return t+x.p; },0) >= remaining
              ? '<button class="btn btn-outline btn-block btn-sm" id="addWithShip" type="button" style="margin-top:12px">Agregar '+(sug.length>1?'los '+(sug.length+1):'ambos')+' y listo</button>'
              : '')+'</div>';
          var shipAll=qs('#addWithShip');
          if(shipAll) shipAll.addEventListener('click', function(){ addMany([currentVariantId()].concat(sug.map(function(s){ return s.id; }))).then(function(){ toast('Listo: tu pedido ya tiene el despacho a '+despachoTxt()); openCartDrawer(); }); });
        }
      }
    }
    /* acordeones */
    qsa('.acc-head').forEach(function(btn){ btn.addEventListener('click', function(){ var item=btn.closest('.acc-item'), body=item.querySelector('.acc-body'); if(item.classList.contains('open')){ item.classList.remove('open'); body.style.maxHeight=null; btn.setAttribute('aria-expanded','false'); } else { item.classList.add('open'); body.style.maxHeight=body.scrollHeight+'px'; btn.setAttribute('aria-expanded','true'); } }); });
    var firstBody=qs('.acc-item.open .acc-body'); if(firstBody) firstBody.style.maxHeight=firstBody.scrollHeight+'px';
    /* arma tu pack */
    var pack=qs('#pdpPack');
    if(pack && qs('[data-packbid]', pack)){
      var disc=Number(pack.getAttribute('data-discount'))||0, addBtn=qs('#packBAddBtn');
      function calc(){
        var checked=qsa('[data-packbid]:checked', pack), sum=0; checked.forEach(function(c){ sum+=Number(c.getAttribute('data-price'))||0; });
        var comboPrice=disc>0 ? Math.round(sum*(100-disc)/100/10)*10 : sum, save=sum-comboPrice, savePct=sum?Math.round(save/sum*100):0;
        qs('#packBTotal').textContent=money(comboPrice);
        qs('#packBSave').textContent = checked.length>1 ? (disc>0 ? 'Ahorras '+money(save)+' ('+savePct+'%) comprándolo en pack, frente a comprarlos por separado' : 'Los '+checked.length+' productos llegan en un solo pedido') : 'Marca al menos un producto más para armar el pack';
        addBtn.disabled=checked.length<2; addBtn.setAttribute('data-ids', checked.map(function(c){ return c.getAttribute('data-packbid'); }).join(','));
      }
      qsa('[data-packbid]', pack).forEach(function(cb){ cb.addEventListener('change', calc); }); calc();
      addBtn.addEventListener('click', function(){ var ids=(addBtn.getAttribute('data-ids')||'').split(',').filter(Boolean); if(ids.length<2) return; addMany(ids).then(function(){ toast('Agregamos tu pack al carro'); openCartDrawer(); }); });
    }
    /* vistos recientemente */
    var recent=recentProducts(p.id, 6), rs=qs('#recentSection');
    if(rs){ if(recent.length){ rs.hidden=false; qs('#recentRail').innerHTML=recent.map(productCardHTML).join(''); } else rs.hidden=true; }
  }

  /* ================= COLECCIÓN / BÚSQUEDA ================= */
  /* Mirar una categoría también cuenta: le preguntamos a las tarjetas de qué son
     y nos quedamos con la que manda en la página. */
  function perfilDesdeLaGrilla(){
    if(CFG.currentPage!=='collection' && CFG.currentPage!=='search') return;
    var cuenta={}, nombres={}, mejor='', max=0, precios=[];
    qsa('.pcard[data-cat]').forEach(function(c){
      var k=(c.getAttribute('data-cat')||'').trim(); if(!k) return;
      cuenta[k]=(cuenta[k]||0)+1; nombres[k]=c.getAttribute('data-catn')||k;
      if(cuenta[k]>max){ max=cuenta[k]; mejor=k; }
      var pr=Number(c.getAttribute('data-price'))||0; if(pr) precios.push(pr);
    });
    if(!mejor) return;
    precios.sort(function(a,b){ return a-b; });
    tocaPerfil(mejor, nombres[mejor], precios.length ? precios[Math.floor(precios.length/2)] : 0, PESO.coleccion);
  }

  function initCollection(){
    perfilDesdeLaGrilla();
    var panel=qs('#filtersPanel'); if(!panel) return;
    var open=qs('#btnOpenFilters'), close=qs('#btnCloseFilters'), scrim=qs('#filtersScrim');
    function openF(){ panel.classList.add('open'); scrim.classList.add('open'); document.documentElement.style.overflow='hidden'; }
    function closeF(){ panel.classList.remove('open'); scrim.classList.remove('open'); document.documentElement.style.overflow=''; }
    if(open){ if(window.innerWidth<=900) open.style.display='inline-flex'; open.addEventListener('click', openF); }
    if(close) close.addEventListener('click', closeF); if(scrim) scrim.addEventListener('click', closeF);
    var sort=qs('#sortSelect'); if(sort) sort.addEventListener('change', function(){ var u=new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href=u.toString(); });
    qsa('form[data-filter-form]').forEach(function(f){ f.addEventListener('change', function(){ f.submit(); }); });
  }

  /* ================= REGALOS ================= */
  function initRegalos(){
    var root=qs('#regalosPage'); if(!root) return;
    function showResults(label, html){
      var sec=qs('#resultsSection'); sec.classList.remove('hidden');
      qs('#resultsLabel').textContent=label;
      qs('#resultsGrid').innerHTML = html || '<p class="finder-vacio">No encontramos productos en este tramo con stock disponible. Prueba con otro rango o mira el catálogo completo.</p>';
      paintWished(sec); sec.scrollIntoView({ behavior:'smooth', block:'start' });
    }
    function pick(key, type){
      var src=qs('[data-results="'+type+':'+key+'"]');
      if(!src) return '';
      if(type!=='price') return src.innerHTML;
      /* el tramo promete un rango: filtramos aunque la colección traiga de todo */
      var min=Number(src.getAttribute('data-min'))||0;
      var maxRaw=Number(src.getAttribute('data-max'))||0;
      var max=maxRaw>0?maxRaw:Infinity;
      var ok=qsa('.pcard', src).filter(function(c){
        var pr=Number(c.getAttribute('data-price'));
        return !isNaN(pr) && pr>=min && pr<max;
      });
      return ok.map(function(c){ return c.outerHTML; }).join('');
    }
    qsa('[data-occ],[data-price]', root).forEach(function(btn){
      btn.addEventListener('click', function(){
        qsa('[data-occ],[data-price]', root).forEach(function(b){ b.classList.remove('active'); });
        var key=btn.getAttribute('data-occ')||btn.getAttribute('data-price'), type=btn.hasAttribute('data-occ')?'occ':'price';
        var twin=qs('[data-'+type+'="'+key+'"]', root); if(twin) twin.classList.add('active');
        showResults(btn.getAttribute('data-label')||btn.textContent.trim(), pick(key,type));
      });
    });
    /* finder 2 pasos */
    var fb=qs('#finderBody'), steps=qs('#finderSteps'); if(!fb) return;
    var pools=qsa('[data-finder-pool]'), bands=qsa('[data-finder-band]');
    var state={ step:1, quien:null, precio:null };
    function opt(key,label){ return '<button class="finder-opt reset-btn" data-finder="'+esc(key)+'">'+esc(label)+'</button>'; }
    function render(){
      steps.innerHTML='<span class="finder-step '+(state.step===1?'active':'done')+'">1</span><span class="finder-line"></span><span class="finder-step '+(state.step===2?'active':(state.step>2?'done':''))+'">2</span><span class="finder-line"></span><span class="finder-step '+(state.step===3?'active':'')+'">3</span>';
      if(state.step===1){
        fb.innerHTML='<h3 class="h3" style="color:#fff;margin-bottom:20px">¿Para quién es el regalo?</h3><div class="finder-opts">'+pools.map(function(p){ return opt(p.getAttribute('data-finder-pool'), p.getAttribute('data-label')); }).join('')+'</div>';
        qsa('[data-finder]', fb).forEach(function(b){ b.addEventListener('click', function(){ state.quien=b.getAttribute('data-finder'); state.step=2; render(); }); });
      } else if(state.step===2){
        fb.innerHTML='<h3 class="h3" style="color:#fff;margin-bottom:20px">¿Cuánto quieres gastar?</h3><div class="finder-opts">'+bands.map(function(b){ return '<button class="finder-opt reset-btn" data-finderprice="'+b.getAttribute('data-finder-band')+'">'+esc(b.getAttribute('data-label'))+'</button>'; }).join('')+'</div><button class="btn btn-ghost btn-sm" id="finderBack" style="margin-top:20px">'+ICO.arrowL+' Volver</button>';
        qsa('[data-finderprice]', fb).forEach(function(b){ b.addEventListener('click', function(){ state.precio=b.getAttribute('data-finderprice'); state.step=3; render(); }); });
        qs('#finderBack').addEventListener('click', function(){ state.step=1; render(); });
      } else {
        var pool=qs('[data-finder-pool="'+state.quien+'"]'), band=qs('[data-finder-band="'+state.precio+'"]');
        var min=Number(band.getAttribute('data-min'))||0, max=Number(band.getAttribute('data-max'))||Infinity;
        var cards=qsa('.pcard', pool), list=cards.filter(function(c){ var pr=Number(c.getAttribute('data-price')); return pr>=min && pr<max; });
        var titulo, bajada;
        if(list.length===0){
          titulo='No encontramos regalos en ese rango';
          bajada='Prueba con otro presupuesto o mira el catálogo completo.';
        } else {
          titulo='Encontramos '+list.length+(list.length===1?' idea para ti':' ideas para ti');
          bajada='Puedes agregarlas directo al carrito.';
        }
        fb.innerHTML='<h3 class="h3" style="color:#fff;margin-bottom:6px">'+titulo+'</h3><p style="color:rgba(255,255,255,.65);font-size:13.5px;margin-bottom:22px">'+bajada+'</p><div class="grid-products" id="finderResults">'+list.map(function(c){ return c.outerHTML; }).join('')+'</div><button class="btn btn-ghost btn-sm" id="finderRestart" style="margin-top:22px">Volver a intentar</button>';
        paintWished(fb);
        qs('#finderRestart').addEventListener('click', function(){ state={ step:1, quien:null, precio:null }; render(); });
      }
    }
    render();
    /* deep links: ?precio=key o #ocasion */
    setTimeout(function(){ var qp=new URLSearchParams(window.location.search), hash=(window.location.hash||'').replace('#',''); var b = qp.get('precio') ? qs('[data-price="'+qp.get('precio')+'"]') : (hash ? qs('[data-occ="'+hash+'"]') : null); if(b) b.click(); }, 60);
  }

  /* ================= PÁGINA CARRITO ================= */
  function initCartPage(){
    var wrap=qs('#cartPageWrap'); if(!wrap) return;
    qsa('[data-qty]', wrap).forEach(function(b){ b.addEventListener('click', function(){ var key=b.getAttribute('data-qty'), op=Number(b.getAttribute('data-op')); var line=cartLines().find(function(l){ return l.key===key; }); if(!line) return; var q=line.quantity+op; (q<=0?removeFromCart(key):setQty(key,q)).then(function(){ window.location.reload(); }); }); });
    qsa('[data-rm]', wrap).forEach(function(b){ b.addEventListener('click', function(){ removeFromCart(b.getAttribute('data-rm')).then(function(){ window.location.reload(); }); }); });
    var sug=qs('#cartPageSuggest');
    if(sug){ var sub=Number(sug.getAttribute('data-subtotal'))||0, inCart=(sug.getAttribute('data-ids')||'').split(',').map(Number); var list=shippingSuggestions(sub, inCart, THRESHOLD).slice(0,2); sug.innerHTML = list.length ? '<div class="ship-suggest">'+list.map(function(sp){ return '<button class="ship-opt reset-btn" data-qadd="'+sp.id+'" data-title="'+esc(sp.t)+'"><img src="'+imgW(sp.img,100)+'" alt="">'+esc(sp.t.slice(0,24))+(sp.t.length>24?'…':'')+'<span class="p">+'+money(sp.p)+'</span></button>'; }).join('')+'</div>' : ''; }
    window.BIX_ON_CART_PAGE = function(){ /* la página se recarga tras cada cambio */ };
  }

  /* ================= VITRINA "PARA TI" =================
     Riel del home que se arma con el perfil. Las tarjetas las pide al servidor
     (Section Rendering API), así salen con los mismos precios, sellos y cuotas que
     el resto del sitio. Si no hay perfil todavía, cae a lo que la persona ya vio;
     si tampoco hay nada, la sección se queda escondida y el home es el de siempre. */
  function initParaTi(){
    var box=qs('#paraTi'); if(!box) return;
    var rail=qs('#paraTiRail'), eyebrow=qs('#paraTiEyebrow'), titulo=qs('#paraTiTitulo'), verTodo=qs('#paraTiVerTodo');
    function mostrar(){ box.hidden=false; if(window.BIX && BIX.initReveal) BIX.initReveal(); }

    function porVistos(){
      var r=recentProducts(0, 8);
      if(r.length<2) return false;
      eyebrow.textContent='Tu historial';
      titulo.textContent='Sigue donde quedaste';
      rail.innerHTML=r.map(productCardHTML).join('');
      paintWished(rail); mostrar(); return true;
    }

    var cat=categoriasTop(1)[0];
    if(!perfilUtil() || !cat){ porVistos(); return; }
    var nombre=nombreCat(cat);
    fetch('/collections/'+encodeURIComponent(cat)+'?section_id=ant-para-ti', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.text() : Promise.reject(); })
      .then(function(html){
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var nuevo=tmp.querySelector('.rail[data-relleno]');
        var cards=nuevo ? nuevo.querySelectorAll('.pcard') : [];
        if(cards.length<3) throw new Error('poco');
        eyebrow.textContent='Para ti';
        titulo.textContent='Porque te interesa '+nombre;
        verTodo.href='/collections/'+cat;
        rail.innerHTML=nuevo.innerHTML;
        paintWished(rail); mostrar();
      })
      .catch(function(){ porVistos(); });
  }

  /* ================= RECOMENDADOS DE LA FICHA =================
     Reemplaza "Completa tu compra" (que mostraba los primeros de la misma colección)
     por los relacionados que calcula Shopify con el catálogo y las ventas reales. */
  function initRecomendados(){
    var rail=qs('#railCross'); if(!rail) return;
    var pid=rail.getAttribute('data-pid'); if(!pid) return;
    fetch('/recommendations/products?section_id=ant-recomendados&product_id='+pid+'&limit=8&intent=related', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.text() : Promise.reject(); })
      .then(function(html){
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var nuevo=tmp.querySelector('.rail[data-relleno]');
        if(!nuevo || nuevo.querySelectorAll('.pcard').length<3) return;   /* nos quedamos con el respaldo */
        rail.innerHTML=nuevo.innerHTML;
        paintWished(rail);
      })
      .catch(function(){});
  }

  /* ================= TE QUEDÓ ALGO EN EL CARRO =================
     Shopify guarda el carro 14 días. Si alguien vuelve y todavía lo tiene, se lo
     recordamos una vez por visita, sin tapar nada ni abrir el cajón de golpe. */
  function initRecordatorioCarro(){
    if(CFG.currentPage==='cart') return;
    try{ if(sessionStorage.getItem('bix_recordado')) return; }catch(e){ return; }
    setTimeout(function(){
      var n=cartCount(); if(!n) return;
      var sub=cartSubtotal(), falta=THRESHOLD-sub;
      try{ sessionStorage.setItem('bix_recordado','1'); }catch(e){}
      var el2=el('<div class="cart-back" role="status">'+ICO.cart+
        '<div class="txt"><b>Dejaste '+n+' '+(n===1?'producto':'productos')+' en tu carro</b>'+
        (falta>0 ? '<span>Te faltan '+money(falta)+' para el despacho a '+despachoTxt()+'</span>'
                 : '<span>Ya tienes el despacho a '+despachoTxt()+'</span>')+'</div>'+
        '<button class="btn btn-primary btn-sm" data-volver-carro type="button">Ver carro</button>'+
        '<button class="cerrar reset-btn" aria-label="Cerrar">'+ICO.close+'</button></div>');
      document.body.appendChild(el2);
      requestAnimationFrame(function(){ el2.classList.add('open'); });
      function fuera(){ el2.classList.remove('open'); setTimeout(function(){ el2.remove(); }, 400); }
      el2.querySelector('[data-volver-carro]').addEventListener('click', function(){ fuera(); openCartDrawer(); });
      el2.querySelector('.cerrar').addEventListener('click', fuera);
      setTimeout(fuera, 12000);
    }, 2500);
  }

  /* ================= SEGUNDA FOTO AL PASAR EL MOUSE ================= */
  /* No viene en el HTML: se inserta al primer hover de cada tarjeta, así la grilla no paga
     el doble de fotos y en pantallas táctiles (donde no hay hover) nunca se descarga. */
  function initHoverFoto(){
    if(!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    document.addEventListener('mouseover', function(e){
      var t=e.target; if(!t || !t.closest) return;
      var wrap=t.closest('.pcard .imgwrap'); if(!wrap || wrap.getAttribute('data-h2')) return;
      wrap.setAttribute('data-h2','1');                 /* una sola vez por tarjeta */
      var url=wrap.getAttribute('data-img2'); if(!url) return;
      var im=document.createElement('img');
      im.className='img2'; im.alt=''; im.width=500; im.height=500;
      im.setAttribute('aria-hidden','true'); im.setAttribute('draggable','false');
      im.addEventListener('load', function(){ wrap.classList.add('has2'); });
      im.src=url; wrap.appendChild(im);
    });
  }

  /* ================= INIT ================= */
  document.addEventListener('DOMContentLoaded', function(){
    wireHeader(); wireOverlays(); updateWishCount(); renderWishDrawer(); paintWished(document);
    fetchCart().then(function(){ renderCartDrawer(); initRecordatorioCarro(); }).catch(function(){});
    setTimeout(initReveal, 30);
    initHero(); initMasonry(); initCyberReloj(); initDestacados(); initProwCarruseles(); initPacks(); initStores(); initPdp(); initCollection(); initRegalos(); initCartPage(); initHoverFoto();
    initParaTi(); initRecomendados();
    if(/customer_posted=true/.test(window.location.search)) toast('¡Listo! Te avisaremos de nuevos lanzamientos y ofertas');
  });

  window.BIX = { money:money, pct:pct, cuota:cuota, qs:qs, qsa:qsa, el:el, waLink:waLink, ICO:ICO, toast:toast, productCardHTML:productCardHTML,
    addToCart:addToCart, addMany:addMany, removeFromCart:removeFromCart, setQty:setQty, cartLines:cartLines, cartSubtotal:cartSubtotal, cartCount:cartCount,
    openCartDrawer:openCartDrawer, closeCartDrawer:closeCartDrawer, renderCartDrawer:renderCartDrawer, isWished:isWished, toggleWish:toggleWish,
    recordView:recordView, recentProducts:recentProducts, shippingSuggestions:shippingSuggestions, openHsSheet:openHsSheet, closeHsSheet:closeHsSheet, initReveal:initReveal };
})();
